<template>
  <ModalConfirmAction
    title="Excluir imagem"
    message="Tem certeza que deseja excluir esta imagem?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="removerImagemTelaDescanso"
  >
    <template #activator="{ on, attrs }">
      <v-btn icon x-small class="descanso-delete-btn" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
      </v-btn>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    id_tela_descanso: Number,
    cod_producao: Number,
    fetchData: Function,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async removerImagemTelaDescanso() {
      try {
        this.loading = true;

        const response = await apiClient.delete(
          `removerProducaoTelaDescanso/${this.cod_producao}/${this.id_tela_descanso}`
        );

        if (response.status === 200) {
          this.$toast.success(response.data.msg);
          await this.fetchData();
        }
      } catch (error) {
        this.$toast.error(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.descanso-delete-btn {
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(4px);
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  .v-icon {
    color: #fff !important;
  }

  &:hover {
    background: rgba(var(--sc-color-error-rgb),0.8) !important;
  }
}
</style>
